// extracted by mini-css-extract-plugin
export default {"title":"ModularConfigurationShare__title___OIOyr","section":"ModularConfigurationShare__section___hs7Yj"};